import type { AgentFleet, AgentPresence } from '@/adapters/apiv1.g';
import type { AgentFleetView, AgentPresenceInfo } from '@/types/core/client';
import type { UUID } from '@/utils/uuid';

function extractAgentPresence(model: AgentPresence): AgentPresenceInfo {
  return {
    clientId: (model.client_id ?? '') as UUID,
    capabilities: model.capabilities ?? [],
    groups: model.groups ?? [],
    version: model.version ?? '',
    hostname: model.hostname ?? '',
    lastSeenAt: model.last_seen_at ?? '',
    staleAfter: model.stale_after ?? '',
  };
}

/**
 * Transform a backend AgentFleet to a frontend AgentFleetView.
 * Preserves the settled flag: an unsettled empty list means "unknown", not "no agents".
 */
export function extractAgentFleet(model: AgentFleet): AgentFleetView {
  return {
    observedAt: model.observed_at ?? '',
    settled: model.settled ?? false,
    agents: (model.agents ?? []).map(extractAgentPresence),
  };
}

export { extractAgentPresence };
